import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0d827794"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "evolution-chart-export-option"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "icons"
};
const _hoisted_5 = {
  class: "icon disabled"
};
const _hoisted_6 = {
  class: "copy icon"
};
const _hoisted_7 = {
  class: ""
};
const _hoisted_8 = {
  class: ""
};
const _hoisted_9 = {
  class: ""
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_align_top_icon = _resolveComponent("align-top-icon");
  const _component_stroked_copy_icon = _resolveComponent("stroked-copy-icon");
  const _component_layers_two_icon = _resolveComponent("layers-two-icon");
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
  const _component_layers_two_dashed_icon = _resolveComponent("layers-two-dashed-icon");
  const _component_app_dropdown = _resolveComponent("app-dropdown");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString($props.title), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_align_top_icon, {
    color: "#616161"
  })]), _createVNode(_component_app_dropdown, {
    "no-caret": false
  }, {
    "button-content": _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_stroked_copy_icon, {
      color: "#616161"
    })])]),
    body: _withCtx(() => [_createVNode(_component_b_dropdown_item, {
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('copy', true))
    }, {
      default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_layers_two_icon), _createTextVNode(" Copy with background ")])]),
      _: 1
    }), _createVNode(_component_b_dropdown_item, {
      onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('copy-no-background', true))
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_layers_two_dashed_icon), _createTextVNode(" Copy transparent background ")])]),
      _: 1
    }), _createVNode(_component_b_dropdown_item, {
      onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('copy', false))
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_layers_two_dashed_icon), _createTextVNode(" Copy with background, no axes ")])]),
      _: 1
    }), _createVNode(_component_b_dropdown_item, {
      onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('copy-no-background', false))
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_layers_two_dashed_icon), _createTextVNode(" Copy transparent background, no axes ")])]),
      _: 1
    })]),
    _: 1
  })])]), _renderSlot(_ctx.$slots, "default", {}, undefined, true)]);
}